export default "__VITE_ASSET__JtcJSDxT__"